import { render, staticRenderFns } from "./emailpreferences.html?vue&type=template&id=40ad8920&scoped=true&external"
import script from "./emailpreferences.vue?vue&type=script&lang=js"
export * from "./emailpreferences.vue?vue&type=script&lang=js"
import style0 from "./emailpreferences.vue?vue&type=style&index=0&id=40ad8920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad8920",
  null
  
)

export default component.exports